import React from 'react';
import './ArticleInfo.css';

export default function ArticleInfo() {
  return (
    <div>ArticleInfo</div>
  )
}
